export function buildPlanEmail({ applicantName, orderRef, planCostDisplay, coverageLimitDisplay, tripInterruptionDisplay, marketingChannelCode, itineraryText, numTravelers, selectedAddOns = [], currency = 'USD' }) {
  return `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>Single Trip Travel Protection Plan</title>
</head>
<body style="margin: 0; padding: 0; font-family: Arial, Helvetica, sans-serif; background-color: #f5f5f5;">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color: #f5f5f5;">
    <tr>
      <td align="center" style="padding: 20px;">
        <table width="600" cellpadding="0" cellspacing="0" border="0" style="background-color: #ffffff; max-width: 600px;">
          
          <!-- Greeting and Intro -->
          <tr>
            <td style="padding: 20px 20px 16px; font-size: 15px; color: #333333;">
              Hello ${applicantName},
            </td>
          </tr>
          <tr>
            <td style="padding: 0 20px 16px; font-size: 14px; line-height: 1.55; color: #333333;">
              Thank you for requesting your BattleFace single trip plan quote. Below is a summary of your selection and reference details. Keep this email for your records or complete your purchase when ready.
            </td>
          </tr>
          <tr>
            <td style="padding: 0 20px 20px; font-size: 12px; color: #777777;">
              Order Reference: <strong>${orderRef}</strong>
            </td>
          </tr>
          
          <!-- Plan Header -->
          <tr>
            <td style="padding: 0 20px 20px;">
              <table width="100%" cellpadding="20" cellspacing="0" border="0" style="border: 2px solid #ed7c1c; border-radius: 8px; background-color: #ffffff;">
                <tr>
                  <td width="60%" style="vertical-align: top;">
                    <div style="color: #666666; font-size: 14px; font-weight: bold; margin-bottom: 5px;">Total Plan Cost:</div>
                    <div style="color: #999999; font-size: 13px;">${itineraryText ? itineraryText : 'Coverage for 365 days'}${typeof numTravelers === 'number' ? ` · ${numTravelers} traveler${numTravelers === 1 ? '' : 's'}` : ''}</div>
                  </td>
                  <td width="40%" style="text-align: right; vertical-align: top;">
                    <div style="color: #ed7c1c; font-size: 32px; font-weight: bold; margin-bottom: 5px;">${planCostDisplay}</div>
                    <div style="color: #ed7c1c; font-size: 13px; text-decoration: underline;">
                      <a href="https://partner.battleface.com/library/landsman-elite-multi-annual" target="_blank" style="color: #ed7c1c; text-decoration: underline;">View Sample Plan</a>
                    </div>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          
          <!-- Section Header -->
          <tr>
            <td style="padding: 20px; text-align: center;">
              <div style="color: #333333; font-size: 16px; font-weight: bold;">Included in your plan</div>
            </td>
          </tr>
          
          <!-- Benefits Header -->
          <tr>
            <td style="padding: 15px 20px; border-bottom: 1px solid #eeeeee;">
              <table width="100%" cellpadding="0" cellspacing="0" border="0">
                <tr>
                  <td width="60%" style="color: #ed7c1c; font-size: 16px; font-weight: bold;">Benefits</td>
                  <td width="40%" style="text-align: right; color: #999999; font-size: 12px;">Maximum Limits<br>per plan term</td>
                </tr>
              </table>
            </td>
          </tr>
          
          <!-- Trip Cancellation -->
          <tr>
            <td style="padding: 20px; border-bottom: 1px solid #eeeeee;">
              <table width="100%" cellpadding="0" cellspacing="0" border="0">
                <tr>
                  <td style="color: #333333; font-size: 14px; font-weight: bold; padding-bottom: 8px;">Trip Cancellation</td>
                   <td style="text-align: right; color: #666666; font-size: 14px; font-weight: bold; white-space: nowrap; padding-bottom: 8px;">${coverageLimitDisplay}</td>
                </tr>
              </table>
              <div style="color: #666666; font-size: 13px; line-height: 1.5;">
                Up to 100% of your pre-paid, non-refundable trip cost if you need to cancel your trip for a covered reason. Maximum trip cost of $20,000 per traveling party.
              </div>
            </td>
          </tr>
          
          <!-- Trip Interruption -->
          <tr>
            <td style="padding: 20px; border-bottom: 1px solid #eeeeee;">
              <table width="100%" cellpadding="0" cellspacing="0" border="0">
                <tr>
                  <td style="color: #333333; font-size: 14px; font-weight: bold; padding-bottom: 8px;">Trip Interruption</td>
                   <td style="text-align: right; color: #666666; font-size: 14px; font-weight: bold; white-space: nowrap; padding-bottom: 8px;">${tripInterruptionDisplay}</td>
                </tr>
              </table>
              <div style="color: #666666; font-size: 13px; line-height: 1.5;">
                Coverage up to 125% of your pre-paid and non-refundable trip cost if a portion of a trip is missed, or if you must return home early due to unforeseen circumstances, including illness, injury, or death.
              </div>
            </td>
          </tr>
          
          <!-- Single Occupancy -->
          <tr>
            <td style="padding: 20px; border-bottom: 1px solid #eeeeee;">
              <table width="100%" cellpadding="0" cellspacing="0" border="0">
                <tr>
                  <td style="color: #333333; font-size: 14px; font-weight: bold; padding-bottom: 8px;">Single Occupancy</td>
                  <td style="text-align: right; color: #666666; font-size: 14px; font-weight: bold; white-space: nowrap; padding-bottom: 8px;">Up to $1,500</td>
                </tr>
              </table>
              <div style="color: #666666; font-size: 13px; line-height: 1.5;">
                Covers if your traveling companion cancels or interrupts their trip for a covered reason and you choose to still go but have additional costs.
              </div>
            </td>
          </tr>
          
          <!-- Trip Delay -->
          <tr>
            <td style="padding: 20px; border-bottom: 1px solid #eeeeee;">
              <table width="100%" cellpadding="0" cellspacing="0" border="0">
                <tr>
                  <td style="color: #333333; font-size: 14px; font-weight: bold; padding-bottom: 8px;">Trip Delay</td>
                  <td style="text-align: right; color: #666666; font-size: 14px; font-weight: bold; white-space: nowrap; padding-bottom: 8px;">$150/day up to $1,000</td>
                </tr>
              </table>
              <div style="color: #666666; font-size: 13px; line-height: 1.5;">
                Provides coverage for the costs of meals, local transportation and accommodations when your trip is unexpectedly delayed at least 6 hours for covered reasons.
              </div>
            </td>
          </tr>
          
          <!-- Baggage & Personal Effects -->
          <tr>
            <td style="padding: 20px; border-bottom: 1px solid #eeeeee;">
              <table width="100%" cellpadding="0" cellspacing="0" border="0">
                <tr>
                  <td style="color: #333333; font-size: 14px; font-weight: bold; padding-bottom: 8px;">Baggage & Personal Effects</td>
                  <td style="text-align: right; color: #666666; font-size: 14px; font-weight: bold; white-space: nowrap; padding-bottom: 8px;">Up to $1,000</td>
                </tr>
              </table>
              <div style="color: #666666; font-size: 13px; line-height: 1.5;">
                For reimbursement of lost, stolen, or damaged luggage, sporting equipment and personal effects. Per-item limit may apply. $0 deductible.
              </div>
            </td>
          </tr>
          
          <!-- Baggage Delay -->
          <tr>
            <td style="padding: 20px; border-bottom: 1px solid #eeeeee;">
              <table width="100%" cellpadding="0" cellspacing="0" border="0">
                <tr>
                  <td style="color: #333333; font-size: 14px; font-weight: bold; padding-bottom: 8px;">Baggage Delay</td>
                  <td style="text-align: right; color: #666666; font-size: 14px; font-weight: bold; white-space: nowrap; padding-bottom: 8px;">Up to $500</td>
                </tr>
              </table>
              <div style="color: #666666; font-size: 13px; line-height: 1.5;">
                Covers the purchase of clothing, toiletries, and other essential items if your luggage is delayed at least 24 hours.
              </div>
            </td>
          </tr>
          
          <!-- Travel Medical -->
          <tr>
            <td style="padding: 20px; border-bottom: 1px solid #eeeeee;">
              <table width="100%" cellpadding="0" cellspacing="0" border="0">
                <tr>
                  <td style="color: #333333; font-size: 14px; font-weight: bold; padding-bottom: 8px;">Travel Medical</td>
                  <td style="text-align: right; color: #666666; font-size: 14px; font-weight: bold; white-space: nowrap; padding-bottom: 8px;">Up to $100,000</td>
                </tr>
              </table>
              <div style="color: #666666; font-size: 13px; line-height: 1.5;">
                Up to $100,000 for the costs to treat a medical emergency, including COVID-19, during a trip. $0 deductible.
              </div>
            </td>
          </tr>
          
          <!-- Emergency Dental (sub-benefit) -->
          <tr>
            <td style="padding: 15px 20px 15px 40px; border-bottom: 1px solid #eeeeee; background-color: #fafafa;">
              <table width="100%" cellpadding="0" cellspacing="0" border="0">
                <tr>
                  <td style="color: #333333; font-size: 14px; font-weight: bold; padding-bottom: 8px;">Emergency Dental</td>
                  <td style="text-align: right; color: #666666; font-size: 14px; font-weight: bold; white-space: nowrap; padding-bottom: 8px;">$750</td>
                </tr>
              </table>
              <div style="color: #666666; font-size: 13px; line-height: 1.5;">
                Coverage for emergency dental expenses related to accidental injury to sound natural teeth, $0 deductible. Included in the Travel Medical coverage limit.
              </div>
            </td>
          </tr>
          
          <!-- Hospital Room & Board (sub-benefit) -->
          <tr>
            <td style="padding: 15px 20px 15px 40px; border-bottom: 1px solid #eeeeee; background-color: #fafafa;">
              <table width="100%" cellpadding="0" cellspacing="0" border="0">
                <tr>
                  <td style="color: #333333; font-size: 14px; font-weight: bold; padding-bottom: 8px;">Hospital Room & Board</td>
                  <td style="text-align: right; color: #666666; font-size: 14px; font-weight: bold; white-space: nowrap; padding-bottom: 8px;">$50/day</td>
                </tr>
              </table>
              <div style="color: #666666; font-size: 13px; line-height: 1.5;">
                Can reimburse up to the daily amount shown for hospital room & board. Included in the Travel Medical coverage limit.
              </div>
            </td>
          </tr>
          
          <!-- Emergency Medical Transportation & Repatriation of Remains -->
          <tr>
            <td style="padding: 20px; border-bottom: 1px solid #eeeeee;">
              <table width="100%" cellpadding="0" cellspacing="0" border="0">
                <tr>
                  <td style="color: #333333; font-size: 14px; font-weight: bold; padding-bottom: 8px;">Emergency Medical Transportation & Repatriation of Remains</td>
                  <td style="text-align: right; color: #666666; font-size: 14px; font-weight: bold; white-space: nowrap; padding-bottom: 8px;">Up to $300,000</td>
                </tr>
              </table>
              <div style="color: #666666; font-size: 13px; line-height: 1.5;">
                Covers the cost of emergency medical transportation to get you to the nearest adequate medical facility, or home, in the event of a medical emergency during your covered trip. Also covers expenses related to repatriation of remains in the event of your death while on the trip.
              </div>
            </td>
          </tr>
          
          ${selectedAddOns.length > 0 ? `
          <!-- Selected Add-Ons Header -->
          <tr>
            <td style="padding: 20px; text-align: center;">
              <div style="color: #333333; font-size: 16px; font-weight: bold;">Selected Add-Ons</div>
            </td>
          </tr>

          <!-- Selected Add-Ons List -->
          ${selectedAddOns.map(addon => `
          <tr>
            <td style="padding: 20px; border-bottom: 1px solid #eeeeee;">
              <table width="100%" cellpadding="0" cellspacing="0" border="0">
                <tr>
                  <td style="color: #333333; font-size: 14px; font-weight: bold; padding-bottom: 8px;">${addon.label}</td>
                  <td style="text-align: right; color: #666666; font-size: 14px; font-weight: bold; white-space: nowrap; padding-bottom: 8px;">${addon.limitDisplay ? addon.limitDisplay : ''}</td>
                </tr>
              </table>
              <div style="color: #666666; font-size: 13px; line-height: 1.5;">
                ${addon.description ? addon.description : ''}
                ${addon.priceDisplay ? `<div style="margin-top:8px;color:#999999;font-size:12px;">Price: ${addon.priceDisplay}</div>` : ''}
                 ${addon.detailsHtml ? `<div style="margin-top:10px;">${addon.detailsHtml}</div>` : ''}
              </div>
            </td>
          </tr>
          `).join('')}
          ` : ''}

          <!-- CTA Button -->
          <tr>
            <td style="padding: 20px;">
              <table width="100%" cellpadding="0" cellspacing="0" border="0">
                <tr>
                  <td align="center" style="background-color: #ed7c1c; border-radius: 8px; padding: 16px;">
                    <a href="https://landsman-singletrip.azurewebsites.net/?mcc=${marketingChannelCode}&orderId=${orderRef}" style="color: #ffffff; font-size: 16px; font-weight: bold; text-decoration: none; display: block;">Proceed to Order</a>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          
        </table>
      </td>
    </tr>
  </table>
</body>
</html>`;
}
